import { logError } from './utilities/logger';

/*
 * this is just thing wrappers around utag_data for now
 * we still don't know if utag_data is something that we can rely on in production
 * so we'll keep the references here so they're easy to swap out for another implementation if necessary
 */
export default {
  /**
   * IETF BCP 47 standard language tag e.g. "en-us"
   */
  getLanguage() {
    try {
      return window.utag_data.Language;
    } catch (error) {
      logError(error, 'utag data error');
      return 'en-us';
    }
  },

  /**
   * Vistaprint's representation of a locale e.g. "Us"
   */
  getVPLocale() {
    try {
      return window.utag_data.Locale;
    } catch (error) {
      logError(error, 'utag data error');
      return 'Us';
    }
  },

  getCouponFriendlyName() {
    try {
      return window.utag_data.CouponFriendlyName;
    } catch (error) {
      logError(error, 'utag data error');
      return undefined;
    }
  },

  getVATPreference() {
    try {
      return window.utag_data.VATState;
    } catch (error) {
      logError(error, 'utag data error');
      return false;
    }
  },
};
